/**
 * Sparkline — 12 tiny bars in an SVG. Zero-dep, no recharts (kept light so
 * the top-of-dashboard render stays snappy).
 *
 * Props:
 *   data   — number[] (usually length 12)
 *   color  — bar fill
 *   height — pixels (default 32)
 *   testId — data-testid on the <svg> for Playwright checks
 */
import React from 'react';

export default function Sparkline({ data = [], color = 'currentColor',
                                    height = 32, testId }) {
  if (!data.length) return null;
  const max = Math.max(1, ...data);
  const barW = 6;
  const gap  = 3;
  const width = data.length * (barW + gap) - gap;
  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height}
         data-testid={testId} role="img" aria-label="12-week trend">
      {data.map((v, i) => {
        const h = Math.max(1, (v / max) * (height - 2));
        return (
          <rect key={i}
                x={i * (barW + gap)}
                y={height - h}
                width={barW}
                height={h}
                rx="1"
                fill={color}
                opacity={i === data.length - 1 ? 1 : 0.55} />
        );
      })}
    </svg>
  );
}
